import { Attachment } from "@super-real/types";

export const calculateImageAttachmentAspectRatio = (
  attachment?: Attachment & { type: "IMAGE" }
): number => {
  return attachment?.dimensions
    ? attachment.dimensions.width / attachment.dimensions.height
    : 0;
};
